import React from 'react';
import { NavLink } from 'react-router';
import { useDemoMode } from '../../demo/DemoContext';
import { useHideOnScroll } from '../../hooks/useHideOnScroll';
import { useNavItems } from './navItems';

export const Navigation: React.FC = () => {
  const { routePrefix } = useDemoMode();
  // Slide the pill away while the user scrolls down the page, back on scroll up.
  const hidden = useHideOnScroll();
  const navItems = useNavItems();

  return (
    <div
      className={`fixed left-0 right-0 flex justify-center z-50 pointer-events-none transition-[transform,opacity] duration-300 motion-reduce:transition-none ${
        hidden ? 'translate-y-32 opacity-0' : 'translate-y-0 opacity-100'
      }`}
      style={{ bottom: `calc(var(--sab) + 0.75rem)` }}
    >
      <nav className={`bg-white/80 backdrop-blur-xl border border-white/40 shadow-xl shadow-mist/20 rounded-full px-6 py-3 flex gap-8 transition-all duration-300 ${hidden ? 'pointer-events-none' : 'pointer-events-auto'}`}>
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === `${routePrefix}/`}
              className={({ isActive }) =>
                `relative flex flex-col items-center justify-center w-12 h-12 transition-all duration-300 ${
                  isActive ? 'text-growth -translate-y-2' : 'text-growth/50 hover:text-growth'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {isActive && (
                    <span className="absolute inset-0 rounded-full bg-growth/8" />
                  )}
                  <Icon className={`w-6 h-6 z-10 ${isActive ? 'stroke-[2.5px]' : 'stroke-2'}`} />
                  {isActive && (
                    <span className="absolute -bottom-4 text-[10px] font-bold tracking-widest uppercase text-growth opacity-100 transition-opacity whitespace-nowrap">
                      {item.label}
                    </span>
                  )}
                </>
              )}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};
